module.exports = __webpack_public_path__ + "static/media/BIT-Weiss.a012b9b9.png";